export {SALESFORCE_ENDPOINTS} from '../util/salesForceActionEndpoints'

let productionUrl = !window.Shopify.shop.includes(`staging`) && !window.Shopify.shop.includes(`test`) && window.location.host.includes(`www`)
export const STORE_URL = productionUrl ? `https://${window.location.host}` : `https://${window.Shopify.shop}`
export const GQL_END_POINT = `${STORE_URL}/api/2024-01/graphql.json`
